export const AppType = {
  LOAD_USER_FROM_STORAGE: 'LOAD_USER_FROM_STORAGE',
  LOAD_USER_FROM_STORAGE_SUCCESS: 'LOAD_USER_FROM_STORAGE_SUCCESS',
  LOAD_USER_FROM_STORAGE_FAIL: 'LOAD_USER_FROM_STORAGE_FAIL',
  LOAD_SETTING_APP: 'LOAD_SETTING_APP',
  LOAD_SETTING_APP_RESULT: 'LOAD_SETTING_APP_RESULT',
  LOAD_SETTING_APP_REQUEST: 'LOAD_SETTING_APP_REQUEST',
}